<script setup lang="ts">
import { X } from "lucide-vue-next";
import { useToasts } from "@/composables/useToasts";

const { toasts, dismiss } = useToasts();
</script>

<template>
  <div
    class="pointer-events-none fixed bottom-4 right-4 z-50 flex w-80 max-w-[90vw] flex-col gap-2"
    aria-live="polite"
  >
    <div
      v-for="t in toasts"
      :key="t.id"
      class="pointer-events-auto flex items-start justify-between gap-2 rounded border bg-bg p-3 text-sm shadow-sm dark:bg-surface-dark"
      :class="{
        'border-status-failed/40 text-status-failed': t.kind === 'error',
        'border-status-ready/40 text-status-ready': t.kind === 'success',
        'border-border text-fg dark:border-border-dark dark:text-fg-dark': t.kind === 'info',
      }"
      role="status"
    >
      <span class="flex-1 leading-snug">{{ t.message }}</span>
      <button
        type="button"
        class="text-fg-muted hover:text-fg dark:hover:text-fg-dark"
        @click="dismiss(t.id)"
        aria-label="Dismiss"
      >
        <X :size="14" />
      </button>
    </div>
  </div>
</template>
